var _circle, _circle2, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 356,
    viewBox: "0 0 368 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178,
    r: 178,
    fill: "#D9EDF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_196_849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 356,
    height: 356
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178,
    r: 178,
    fill: "#E5E7EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_196_849)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_196_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 212.063L177.206 131L287.412 212.063H67Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 358.063H287.412V212.063H67V358.063Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 358.063L177.206 285.06L67 212.063V358.063Z",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.413 358.063L177.207 285.06L287.413 212.063V358.063Z",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.206 285.06L150.294 267.234L67 358.063H287.412L204.118 267.234L177.206 285.06Z",
    fill: "#1B92C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.206 285.06L67 212.063L177.206 265.971L287.412 212.063L204.118 267.234L177.206 285.06Z",
    fill: "#202D8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.119 267.234L287.413 212.063L204.119 267.234Z",
    fill: "#2E8AB0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.8 161.6C338.588 161.6 367.6 132.588 367.6 96.8C367.6 61.012 338.588 32 302.8 32C267.012 32 238 61.012 238 96.8C238 132.588 267.012 161.6 302.8 161.6Z",
    fill: "url(#paint0_linear_196_849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.218 70.7825C286.508 67.0725 280.492 67.0725 276.782 70.7825C273.073 74.4925 273.073 80.5075 276.782 84.2175L289.065 96.5L276.782 108.782C273.073 112.492 273.073 118.508 276.782 122.218C280.492 125.928 286.508 125.928 290.218 122.218L302.5 109.935L314.782 122.218C318.492 125.928 324.508 125.928 328.218 122.218C331.928 118.508 331.928 112.492 328.218 108.782L315.935 96.5L328.218 84.2175C331.928 80.5075 331.928 74.4925 328.218 70.7825C324.508 67.0725 318.492 67.0725 314.782 70.7825L302.5 83.065L290.218 70.7825Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_196_849",
    x: 52,
    y: 116,
    width: 250.414,
    height: 257.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.666667 0 0 0 0 0.886274 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_196_849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_196_849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_849",
    x1: 253,
    y1: 55,
    x2: 351,
    y2: 136.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87F7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailError);
export default __webpack_public_path__ + "static/media/email-error.b3dafad47b8dd7627eec2e9715c9822c.svg";
export { ForwardRef as ReactComponent };